import React, { Component } from 'react';
import tableDragger from 'table-dragger';
import Modal from 'react-responsive-modal';
import swal from 'sweetalert';
import { baseUrl } from '../../Comman/apiEndPoints';
import imageCompression from 'browser-image-compression';
import { withNamespaces } from 'react-i18next';
import InputWithExtra from '../../Comman/components/InputWithExtra';

import { Editor } from 'primereact/editor';
// import Quill from 'quill';

const options = {
    maxSizeMB: 2.0,          // (default: Number.POSITIVE_INFINITY)
    maxWidthOrHeight: 600,   // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    useWebWorker: true,      // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
    maxIteration: 10        // optional, max number of iteration to compress the image (default: 10)
}
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
var result_arr = [];
class FAQComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            // image: null,
            isEdit: false,
            id: 0,
            faqModel: {
                question: '',
                answer: '',
                // PageLogo : ''
            }
        }
        this.handleInput = this.handleInput.bind(this);
        this.saveSequence = this.saveSequence.bind(this);
    }

    componentDidUpdate() {
        let self = this;
        var el = document.getElementById('table');
        if (el.rows.length > 1) {
            var dragger = tableDragger(el, {
                mode: 'row',
                dragHandler: '.handle',
                onlyBody: true,
                animation: 100
            });
            dragger.on('drop', function (oldIndex, newIndex) {
                // console.log("oldIndex", oldIndex);
                // console.log("newIndex", newIndex);
                if (self.props.FAQDetails.FAQList.length > 0) {
                    var arr = self.props.FAQDetails.FAQList;
                    var sortedArr = self.array_move(arr, oldIndex - 1, newIndex - 1);

                    result_arr = sortedArr.filter((item, index) => {
                        if (item) {
                            item.PageSequence = index + 1;
                        }
                        return sortedArr;
                    });
                    // console.log("result_arr",result_arr);
                }
            });
        }
    }
    array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    };
    componentWillReceiveProps(nextProps) {
        if (nextProps.FAQDetails.message != this.props.FAQDetails.message) {
            if (nextProps.FAQDetails.statusCode == 200) {
                swal(nextProps.FAQDetails.message, {
                    icon: "success",
                });
                this.props.getFAQListData();
            }
        }
    }
    openModal = () => {
        this.setState({ openModal: true })
    }
    closeModal = () => {
        this.setState({ openModal: false })
        this.setState({ isEdit: false })
        this.setState({
            faqModel: {
                question: '',
                answer: '',
                // PageLogo : ''
            }
        })
    }
    handleInput = (e, label) => {
        let value = e.htmlValue;
        let name = label;
        this.setState(prevState => ({
            faqModel:
                { ...prevState.faqModel, [name]: value }
        }))
        // sleep(3000).then(() => {
        //     console.log("setstate", this.state);
        // })
    }
    // imageUpload = (event) => {
    //     let file = event.target.files[0];
    //     var self=this;
    //     let reader = new FileReader();
    //     imageCompression(file, options)
    //     .then(function (compressedFile) {
    //         self.setState({ image : compressedFile})
    //         reader.readAsDataURL(compressedFile); 
    //         reader.onloadend = function() {
    //             self.setState(prevState => ({ faqModel : 
    //                 {...prevState.faqModel,
    //                     PageLogo: reader.result,
    //                 },
    //                 }))
    //         }
    //     })
    //     .catch(function (error) {
    //         console.log(error);
    //     });
    //     // let reader = new FileReader();
    //     // reader.onload = () => {
    //     //     this.setState({ image : file})
    //     //     this.setState( prevState => ({ newCarouselData : 
    //     //         {...prevState.newCarouselData, PageLogo : reader.result}
    //     //     }))
    //     //   };
    //     //   reader.readAsDataURL(file);
    //   }
    delete(id) {
        const { t } = this.props;
        swal({
            title: `${t('Carousel Setting.Are you sure you want to delete this data')}`,
            text: `${t('Carousel Setting.Once deleted, you will not be able to recover this data')}`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    let payload = { "ID": [id] }
                    this.props.deleteFAQItem(payload);
                } else {
                    swal(`${t('Carousel Setting.Data not deleted')}`);
                }
            });
    }
    add = () => {
        const { t } = this.props;
        if (this.state.faqModel.question != null && this.state.faqModel.question.length > 0 && this.state.faqModel.answer != null && this.state.faqModel.answer.length > 0) {
            let payload =
            {
                Question: this.state.faqModel.question,
                Answer: this.state.faqModel.answer
            }
            this.props.addFAQ(payload);
            this.setState({ openModal: false })
            this.setState({
                faqModel: {
                    question: '',
                    answer: '',
                }
            })
        }
        else {
            swal(`${t('Carousel Setting.Please enter question and answer')}`);
        }
    }
    update = () => {
        const { t } = this.props;

        if (this.state.id > 0 && this.state.faqModel.question != null && this.state.faqModel.question.length > 0 && this.state.faqModel.answer != null && this.state.faqModel.answer.length > 0) {
            let payload = {
                "ID": this.state.id,
                "Question": this.state.faqModel.question,
                "Answer": this.state.faqModel.answer
            }
            this.props.updateFAQ(payload);
            this.setState({
                isEdit: false,
                id: 0
            })
            this.setState({
                faqModel: {
                    question: '',
                    answer: '',
                    // PageLogo: ''
                }
            })
        }
        else {
            swal(`${t('Carousel Setting.Please enter question and answer')}`);
        }
    }
    openEditModal = (item) => {
        this.setState({
            isEdit: true,
            id: item.ID,
            // image : item.PageLogo,
            // faqModel: {
            // question: item.Question,
            // answer: item.Answer,
            // PageLogo: baseUrl + item.PageLogo
            // }
        })

        sleep(500).then(() => {
            document.getElementsByClassName("ql-editor")[0].innerHTML = item.Question;
            document.getElementsByClassName("ql-editor")[1].innerHTML = item.Answer;
        })
    }
    // deleteImage = () =>{
    //     this.setState({ image: null})
    //     this.setState( prevState => ({ newCarouselData : 
    //         {...prevState.newCarouselData, PageLogo : ''}
    //     }))
    //     sleep(3000).then(() => {
    //         console.log("setstate1",this.state);
    //     })
    //   }
    saveSequence() {
        let prevArr = this.props.FAQDetails.FAQList;
        let requestPayload = result_arr.length ? result_arr : prevArr;
        this.props.saveSequenceList(requestPayload);
    }
    // renderHeader() {

    //     // return (
    //     //     <span className="ql-formats">
    //     //         <button className="ql-bold" aria-label="Bold"></button>
    //     //         <button className="ql-italic" aria-label="Italic"></button>
    //     //         <button className="ql-underline" aria-label="Underline"></button>
    //     //     </span>
    //     // );
        
    //     // var editor = new Quill(container);

    //     var toolbarOptions = [
    //         ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    //         // ['blockquote', 'code-block'],
          
    //         // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    //         [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    //         // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    //         // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    //         [{ 'direction': 'rtl' }],                         // text direction
          
    //         [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    //         [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          
    //         [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    //         [{ 'font': [] }],
    //         [{ 'align': [] }],
          
    //         // ['clean']                                         // remove formatting button
    //       ];
    //       var quill = new Quill('#editor', {
    //         modules: {
    //           toolbar: toolbarOptions
    //         },
    //         theme: 'snow'
    //       });
    //     //   var editor = new Quill('#editor', options);
    // }
    render() {
        // this.renderHeader();
        const { t } = this.props;
        return (
            <div className="container carousel-page">
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Carousel Setting.Frequently Asked Question Setting')}</h2>
                    <div className="text-right m-b-25 ">
                        <button type="button" className="btn btn-primary edit-carousel"
                            onClick={this.openModal}>{t('Carousel Setting.Add')}</button>
                        <button type="button" className="btn btn-primary"
                            onClick={this.saveSequence}>{t('Carousel Setting.Save Sequence')}</button>
                    </div>
                </div>
                <div className="overflow-scroll">
                    <table id="table">
                        <thead>
                            <tr>
                                <th>{t('Carousel Setting.Page Sequence')}</th>
                                <th>{t('First_Responder.Question')}</th>
                                <th>{t('First_Responder.Answer')}</th>
                                {/* <th>{t('Carousel Setting.Image for Carousel')}</th> */}
                                <th>{t('Carousel Setting.Action')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                (this.props.FAQDetails && this.props.FAQDetails.FAQList.length) ?
                                    this.props.FAQDetails.FAQList.map(item =>
                                        <tr key={item.ID}>
                                            <td className="handle width-13">{item.PageSequence}</td>
                                            {item.Question.length > 40 ?
                                                <td className="handle width-20"
                                                    dangerouslySetInnerHTML={{ __html: item.Question.substr(0, 40) + '..................' }} ></td>
                                                :
                                                <td className="handle width-20"
                                                    dangerouslySetInnerHTML={{ __html: item.Question }} ></td>
                                            }
                                            {item.Answer.length > 40 ?
                                                <td className="handle width-20"
                                                    dangerouslySetInnerHTML={{ __html: item.Answer.substr(0, 40) + '.....................' }} ></td>
                                                :
                                                <td className="handle width-20"
                                                    dangerouslySetInnerHTML={{ __html: item.Answer }} ></td>
                                            }

                                            {/* <td className="handle width-20"><img src={baseUrl + item.PageLogo} width="80px"></img></td> */}
                                            <td className="handle width-20">
                                                <button type="button" className="btn btn-primary edit-carousel"
                                                    onClick={this.openEditModal.bind(this, item)}>{t('Alarm Setting.Edit')}</button>
                                                <button type="button" className="btn btn-primary"
                                                    onClick={this.delete.bind(this, item.ID)}>{t('First_Responder.Delete')}</button>
                                            </td>
                                        </tr>
                                    ) :
                                    <p>{t('Feedback Setting.No records found')}</p>
                            }
                        </tbody>
                    </table>
                </div>
                <Modal open={this.state.openModal} onClose={this.closeModal} center>
                    <div className="modal1 alarmsetmodal">
                        <div className="progressbar-heading grids-heading">
                            <h2>{t('Carousel Setting.Add FAQ')}</h2>
                        </div>
                        <div className="forms add-device setting-panel">
                            <div className="form-three widget-shadow">
                                <div className=" panel-body-inputin">
                                    <form className="form-horizontal modalForm">
                                        {/* <div className="form-group">
                                            <label className="col-sm-3 control-label">
                                                Page Sequence
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="number"
                                                    id="PageSequence"
                                                    name={'PageSequence'}
                                                    value={this.state.newCarouselData.PageSequence}
                                                    className="form-control1"
                                                    onChange={this.handleInput}
                                                />
                                            </div>
                                        </div> */}
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('First_Responder.Question')}</label>
                                            <div className="col-sm-9">
                                                <Editor style={{ height: '200px' }} className="editor-email" name={'question'}
                                                    value={this.state.faqModel.question}
                                                    onTextChange={(e) => this.handleInput(e, 'question')}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('First_Responder.Answer')}</label>
                                            <div className="col-sm-9">
                                                {/* <input
                                                    type="text"
                                                    id="answer"
                                                    name={'answer'}
                                                    value={this.state.faqModel.answer}
                                                    className="form-control1"
                                                    onChange={this.handleInput}
                                                /> */}
                                                <Editor style={{ height: '200px' }} className="editor-email" name={'answer'}
                                                    value={this.state.faqModel.answer}
                                                    onTextChange={(e) => this.handleInput(e, 'answer')} />
                                            </div>
                                        </div>
                                        {/* <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('Carousel Setting.Upload Image for Carousel')}</label>
                                            <div className="col-sm-9 image-width-100">
                                                <img src={this.state.newCarouselData.PageLogo}
                                                    className={this.state.newCarouselData.PageLogo ? "image-logo" : ''} />
                                                <input type='file' accept="image/*" name={'PageLogo'} onChange={this.imageUpload}
                                                    id="addImageUpload" className="hide_input_type_file" />
                                                <label for="addImageUpload" className="choose-file-btn" style={{ color: 'black' }}>{t('Notification Setting.Select Image')}</label>
                                            </div>
                                        </div> */}
                                        <div className="form-group">
                                            <div className="col-sm-offset-5 col-sm-6">
                                                <p>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary general-btn"
                                                        onClick={this.add}
                                                    >
                                                        {t('Alarm Setting.Save')}
                                                    </button>
                                                </p>
                                            </div>
                                        </div>
                                    </form></div></div></div>
                    </div>
                </Modal>
                <Modal open={this.state.isEdit} onClose={this.closeModal} center>
                    <div className="modal1 alarmsetmodal">
                        <div className="progressbar-heading grids-heading">
                            <h2>{t('Carousel Setting.Edit FAQ')}</h2>
                        </div>
                    </div>
                    <div className="forms add-device setting-panel">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                <form className="form-horizontal modalForm">
                                    <div className="form-group">
                                        <label className="col-sm-3 control-label">{t('First_Responder.Question')}</label>
                                        <div className="col-sm-9">
                                            {/* <InputWithExtra
                                                type="text"
                                                id="question"
                                                name={'question'}
                                                value={this.state.faqModel.question}
                                                className="form-control1 FR-edit-details"
                                                onChange={this.handleInput}
                                            /> */}
                                            <Editor style={{ height: '200px' }} className="editor-email" name={'question'}
                                                value={this.state.faqModel.question}
                                                onTextChange={(e) => this.handleInput(e, 'question')} />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-3 control-label">{t('First_Responder.Answer')}</label>
                                        <div className="col-sm-9">
                                            {/* <InputWithExtra
                                                type="text"
                                                id="answer"
                                                name={'answer'}
                                                value={this.state.faqModel.answer}
                                                className="form-control1 FR-edit-details"
                                                onChange={this.handleInput}
                                            /> */}
                                            <Editor style={{ height: '200px' }} className="editor-email" name={'answer'}
                                                value={this.state.faqModel.answer}
                                                onTextChange={(e) => this.handleInput(e, 'answer')} />
                                        </div>
                                    </div>
                                    {/* <div className="form-group">
                                        <label className="col-sm-3 control-label">{t('Carousel Setting.Image for Carousel')}</label>
                                        <div className="col-sm-9">
                                            {this.state.newCarouselData.PageLogo ?
                                                <div>
                                                    <img src={this.state.newCarouselData.PageLogo} width="300px" height="auto" />
                                                    <button type="button" className="btn btn-primary del-img" onClick={this.deleteImage}>{t('Carousel Setting.Delete Image')}</button>
                                                </div>
                                                :
                                                <div>
                                                    <input type='file' accept="image/*" name={'PageLogo'} onChange={this.imageUpload}
                                                        id="editImageUpload" className="hide_input_type_file" />
                                                    <label for="editImageUpload" className="choose-file-btn" style={{ color: 'black' }}>{t('Notification Setting.Select Image')}</label>
                                                    
                                                </div>
                                            }

                                        </div>
                                    </div> */}
                                    <div className="form-group">
                                        <div className="col-sm-offset-5 col-sm-6">
                                            <p>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary general-btn"
                                                    onClick={this.update}
                                                >
                                                    {t('Alarm Setting.Save')}
                                                </button>
                                            </p>
                                        </div>
                                    </div>
                                </form></div></div></div>
                </Modal>
            </div>
        )
    }
}
export default withNamespaces()(FAQComponent);